module.exports = __webpack_public_path__ + "img/workspace.a2ac46d0.svg";